import React from 'react';
// import { styled } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
// import Link from 'next/link';
import { dataConstants } from '../../../constants';
import { getRandomStr } from '../../../helpers';
// import formulaUtil from '../../../helpers/formula';
// import { groupBy } from 'lodash';
// import D3Chart from '../../_common/D3Chart';
// import { addCommas, getChartSeriesColor, getCssBarXPos } from '../../../utils';
// import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
// import Clipboard from '../../_common/Clipboard';
// import ShareThis from '../../_common/ShareThis';
import dynamic from 'next/dynamic';
import LoadingItem from '../../_common/Skeleton/stock';
import NoData from '../../_common/NoData';
// import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';
// import Collapse from '@mui/material/Collapse';
// import SquareRoundedIcon from '@mui/icons-material/SquareRounded';

// import GDPGrowthBreakUp from './GDPGrowthBreakUp';
// import HistoricalGDPGrowth from './HistoricalGDPGrowth';
// import HistoricalGDPChained from './HistoricalGDPChained';
// import GDPComponents from './GDPComponents';


const GDPGrowthBreakUp = dynamic(() => import('./GDPGrowthBreakUp'),
  { loading: () => <LoadingItem /> })
const HistoricalGDPGrowth = dynamic(() => import('./HistoricalGDPGrowth'),
  { loading: () => <LoadingItem /> })
const HistoricalGDPChained = dynamic(() => import('./HistoricalGDPChained'),
  { loading: () => <LoadingItem /> })
const GDPComponents = dynamic(() => import('./GDPComponents'),
  { loading: () => <LoadingItem /> })

const { ECO_SECTION_CODES } = dataConstants || {};

// const margin_left = 6;


const USGDP = ({ data, themes, getChartData, selectedInfo, onChangeInfo, adStyle, doAppAction }) => {
  const [snackPack, setSnackPack] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleClick = (message) => () => {
    setSnackPack((prev) => [...prev, { message, key: new Date().getTime() }]);
  };

  // const handleClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setOpen(false);
  // };

  // const handleExited = () => {
  //   setMessageInfo(undefined);
  // };

  const gdata = {};
  const dataArr = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK) ? data.filter(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK) : undefined;

  dataArr && dataArr.forEach(d => {
    gdata[d.settings && d.settings.dataSetName ? d.settings.dataSetName : d.section_code] = (d.tabData || []);
  });

  // const gdpBreak = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_CHART) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_CHART) : undefined;
  // const gdpBreakChart = gdpBreak && gdpBreak.tabData && gdpBreak.tabData.length > 0 ? getChartData(gdpBreak.tabData[0], getTabData(gdata, gdpBreak, ECO_SECTION_CODES.GDP_BREAK)) : undefined;

  //gdp break chart
  const gdpBreakT = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_T) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_T) : undefined;
  const gdpBreakData = gdpBreakT && gdpBreakT.tabData && gdpBreakT.tabData.length > 0 ? gdpBreakT.tabData : undefined;

  //current gdp info
  const realGDP = gdpBreakT && gdpBreakT.settings && gdpBreakT.settings.cols ? gdpBreakT.settings.cols.find(d => d.isTitle) : undefined;
  const realGDPData = gdpBreakData && realGDP ? gdpBreakData.find(d => realGDP.code === d.code) : undefined;

  // //gdp break table
  // const gdpBreakTbl = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_TABLE) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_TABLE) : undefined;
  // const gdpBreakTableData = gdpBreakTbl && gdpBreakTbl.tabData && gdpBreakTbl.tabData.length > 0 ? gdpBreakTbl.tabData : undefined;
  // const gdpBreakTblStruct = gdpBreakTbl && gdpBreakTableData && gdpBreakTbl.settings && gdpBreakTbl.settings.table ? getGdpTableStruct(gdpBreakTableData, gdpBreakTbl.settings.table) : undefined;

  // //gdp history pct chart
  // const gdpHistPct = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_HIST_PCT) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_HIST_PCT) : undefined;
  // const gdpHistPctChart = gdpHistPct && gdpHistPct.tabData && gdpHistPct.tabData.length > 0 ? getChartData(gdpHistPct.tabData[0], getTabData(gdata, gdpHistPct, ECO_SECTION_CODES.GDP_BREAK)) : undefined;

  // //gdp history dollar chart
  // const gdpHistDollar = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_HIST_DOLLAR) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_HIST_DOLLAR) : undefined;
  // const gdpHistDollarChart = gdpHistDollar && gdpHistDollar.tabData && gdpHistDollar.tabData.length > 0 ? getChartData(gdpHistDollar.tabData[0], getTabData(gdata, gdpHistDollar, ECO_SECTION_CODES.GDP_BREAK)) : undefined;

  return (
    <NoData noData={!data && !data?.length > 0} >
      <Box component="div" className="gdp-section">
        <Box component="div" className="row sum-r eco-gdp-over">
          <Box component="div" className="col-md-12">
            <Box className="option-content prod-body" component="div" sx={{ mb: 1.5 }}>
              <Grid container spacing={1.5}>
                <Grid size={{ xs: 12, md: 4 }}>
                  {realGDPData && gdpBreakT &&
                    <Box component="div" className="col-md-4" sx={{ mt: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.4, px: 3, mt: 1.6, color: 'text.link' }} >
                        <Typography variant="h2" className="option-title" sx={{ fontSize: '1.2rem', fontWeight: '600' }} >
                          Real GDP
                        </Typography>
                        <Typography variant="caption" className="option-title" sx={{ fontSize: '1.2rem', fontWeight: '600' }} >
                          {realGDPData.value}%
                        </Typography>
                      </Box>
                      {gdpBreakT.settings.order.map(s => {
                        const item = gdpBreakData.find(d => d.code === s);
                        const col = gdpBreakT.settings.cols.find(d => d.code === s && !d.isTitle);
                        return (item && (item.value !== undefined && item.value !== null) && col ?
                          <Box key={getRandomStr(3)} className="eco-break-item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.4, px: 3, }} >
                            <Typography variant="body1" className="option-title" sx={{ fontSize: '.875rem' }} >
                              {col.desc || item.description}
                            </Typography>
                            <Typography variant="body1" className="option-title" sx={{ fontSize: '.875rem' }} >
                              {col.isPct ? `${item.value}%` : item.value}
                            </Typography>
                          </Box>
                          : null);
                      })}
                    </Box>}
                </Grid>
                <Grid size={{ xs: 12, md: 8 }} sx={{ mt: 1.5 }}>
                  <GDPGrowthBreakUp
                    data={data}
                    gdata={gdata}
                    themes={themes}
                    onChangeInfo={onChangeInfo}
                    handleClick={handleClick}
                    getChartData={getChartData}
                    selectedInfo={selectedInfo}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box component="div" className="row sum-r eco-gdp-break">
          <Box component="div" className="col-md-12">
            <Box className="option-content prod-body" component="div" sx={{ mb: 1.5 }}>
              <Grid container spacing={1.5}>
                <Grid size={{ xs: 12, md: 5 }}>
                  <HistoricalGDPGrowth
                    data={data}
                    gdata={gdata}
                    themes={themes}
                    onChangeInfo={onChangeInfo}
                    handleClick={handleClick}
                    getChartData={getChartData}
                    selectedInfo={selectedInfo}
                  />
                  <HistoricalGDPChained
                    data={data}
                    gdata={gdata}
                    themes={themes}
                    onChangeInfo={onChangeInfo}
                    handleClick={handleClick}
                    getChartData={getChartData}
                    selectedInfo={selectedInfo}
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 7 }}>
                  <GDPComponents
                    data={data}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </NoData>
  );
}

export default (USGDP);
